<template>
  <div>
    <p class="text-muted" v-if="title">
      <strong>{{ title }}</strong>
    </p>
    <v-carousel
      :perPage="perPage"
      :autoplay="true"
      :autoplayTimeout="autoplayTimeout"
      :paginationEnabled="false"
      :loop="true"
      :speed="speed"
    >
      <v-slide
        v-for="organisation in organisations"
        :key="organisation.id"
      >
        <div class="h-100 d-flex justify-content-center align-items-center">
          <router-link
            :to="{name: 'organisation-detail', params: {slug: organisation.slug}}"
            class="d-flex justify-content-center align-items-center"
          >
            <img
              :src="organisation.logo"
              class="img-thumbnail w-50 w-md-75 p-4"
              :alt="organisation.name"
            >
          </router-link>
        </div>
      </v-slide>
    </v-carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'OrganisationCarousel',
  props: {
    perPage: {
      type: Number,
      default() {
        return 8;
      },
    },
    organisations: {
      type: Array,
      required: true,
    },
    speed: {
      type: Number,
      default() {
        return 2000;
      },
    },
    autoplayTimeout: {
      type: Number,
      default() {
        return 5000;
      },
    },
    title: {
      type: String,
      required: false,
    },
  },
  components: {
    'v-carousel': Carousel,
    'v-slide': Slide,
  },
};
</script>
